import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const I18N_PREFIX = 'knowledgeContentUI.importArticles.panel';
const Suggestion = ({
  langKey
}) => /*#__PURE__*/_jsx(View, {
  marginBlockStart: "500",
  as: "div",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `${I18N_PREFIX}.${langKey}.suggestion`
  })
});
Suggestion.propTypes = {
  langKey: PropTypes.string.isRequired
};
export default Suggestion;